import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  standalone: true,
  selector: "app-prefix-xpr",
  imports: [TemplateHTMLComponent],
  templateUrl: "./prefix-xpr.component.html",
  styleUrl: "./prefix-xpr.component.less",
})
export class PrefixXprComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["xpr"];
  }
}
